import { useTranslation } from "localization/localization";
import s from "./StuffingCalculationLoader.module.scss";

type StuffingCalculationLoaderProps = {
  title?: string;
  description?: string;
};

export const StuffingCalculationLoader = ({ title, description }: StuffingCalculationLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={s.root} role="status" aria-live="polite">
      <div className={s.visual} aria-hidden>
        <span className={s.ring} />
        <span className={s.ringSecondary} />
        <div className={s.core}>
          <span className={s.box} />
          <span className={s.box} />
          <span className={s.box} />
        </div>
      </div>

      <h3 className={s.title}>{title ?? t("Calculating stuffing result")}</h3>
      <p className={s.description}>{description ?? t("Optimizing cargo placement for your transport units")}</p>

      <div className={s.progress} aria-hidden>
        <span className={s.progressBar} />
      </div>
    </div>
  );
};
